export function registerSW() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          console.log('[PWA] Service worker registered:', reg.scope);
          // Check for updates periodically
          setInterval(() => reg.update(), 60 * 60 * 1000); // hourly
        })
        .catch((err) => {
          console.log('[PWA] Service worker registration failed:', err);
        });
    });
  }
}
